import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
    data:[],
    isPaying:false,
    status:null,
}

const token = userObj?.token

export const addPayment = createAsyncThunk(
    'wallets/addWalletPayment',
    async (data, {rejectWithValue}) => {
        
        try{
            const response = await axios.post("/Wallets/AddWalletPayment",data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const addPaymentSlice = createSlice({
    name: 'addPayment',
    initialState,
    reducers: {},
    extraReducers:{
        [addPayment.pending]: (state, action) => {
            state.status='pending';
            state.isPaying=true;
        },
        [addPayment.fulfilled]: (state, action) => {
            state.status='success';
            state.isPaying=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [addPayment.rejected]: (state, action) => {
            state.status='failed';
            state.isPaying=false;
        }
    }
})

export default addPaymentSlice.reducer;